import { render, staticRenderFns } from "./standard_breakdown_quarter.vue?vue&type=template&id=b258d2c4"
import script from "./standard_breakdown_quarter.vue?vue&type=script&lang=js"
export * from "./standard_breakdown_quarter.vue?vue&type=script&lang=js"
import style0 from "./standard_breakdown_quarter.vue?vue&type=style&index=0&id=b258d2c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports